import { Alert, Box } from '@mui/material';
import { keyframes } from '@emotion/react';

// Animation for both border and text color
const blinkBorderAndText = keyframes`
  0%, 100% {
    border-color: #BE9F55;
    color: #BE9F55;
  }
  50% {
    border-color: #4b4b4a;
    color: #4b4b4a;
  }
`;

const DepartureNote = () => {
  return (
    <Box sx={{ my: -1 }}>
      <Alert
        severity="info"
        variant="outlined"
        sx={{
          p: '4px 8px',
          backgroundColor: '#fffdf5',
          borderColor: '#BE9F55',
          fontSize: '0.85rem',
          fontWeight: 500,
          animation: `${blinkBorderAndText} 1.5s linear infinite`,
          '& .MuiAlert-icon': {
            color: '#BE9F55',
          },
        }}
      >
        <strong>Please Note: </strong><li>The data shown is updated with a 24-hour delay and does not include today’s latest bookings or changes.</li>
        <li>All dates shown are based on Departure Dates.</li>
        <li>All commission values are estimated and may not reflect final commission amounts.</li>
      </Alert>
    </Box>
  );
};

export default DepartureNote;
